'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var _extends = require('../../extends-733dd656.js');
var objectWithoutProperties = require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
var taggedTemplateLiteral = require('../../taggedTemplateLiteral-f923b98d.js');
require('styled-components');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
var xstyledPropTypes_es = require('../../xstyled-prop-types.es-4220f7f4.js');
require('../../unsupportedIterableToArray-f175acfa.js');
var styles_breakpoints = require('../../breakpoints-ee0a4ae5.js');
require('../GlobalStyle/GlobalStyle.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
var utils_logger_logDeprecatedFeature_logDeprecatedFeature = require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
var components_NuDSProvider_NuDSProvider = require('../NuDSProvider/NuDSProvider.js');
var utils_isType_isType = require('../../utils/isType/isType.js');
var defineProperty = require('../../defineProperty-3cad0327.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
var styles_colors_colorVariantsShape = require('../../styles/colors/colorVariantsShape.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/intl/intlAriaAttrs.js');
var utils_hooks_useIntlAriaAttrs = require('../../utils/hooks/useIntlAriaAttrs.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function _templateObject15() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["", ""]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n  font-family: ", ";\n  margin: 0;\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  white-space: normal;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    font-weight: 500;\n    letter-spacing: -0.01em;\n    font-size: 0.875rem;\n    line-height: 1.14;\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    font-weight: 500;\n    letter-spacing: -0.02em;\n    font-size: 1rem;\n    line-height: 1.5;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    font-weight: 500;\n    letter-spacing: -0.01em;\n    font-size: 1.125rem;\n    line-height: 1.32;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    font-family: ", ";\n    font-weight: 400;\n    letter-spacing: -0.01em;\n    font-size: 1.125rem;\n    line-height: 1.32;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    font-weight: 500;\n    letter-spacing: -0.03em;\n    font-size: 1.125rem;\n    line-height: 1.2;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    font-family: ", ";\n    font-weight: 400;\n    letter-spacing: -0.01em;\n    font-size: 1rem;\n    line-height: 1.25;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n      font-size: 1.5rem;\n      line-height: 1.32;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n      font-weight: 500;\n      letter-spacing: -0.03em;\n      font-size: 1.25rem;\n      line-height: 1.25;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n      font-size: 3rem;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n      font-weight: 500;\n      letter-spacing: -0.03em;\n      font-size: 1.75rem;\n      line-height: 1.16;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n      font-size: 6rem;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n      font-weight: 500;\n      letter-spacing: -0.03em;\n      font-size: 2rem;\n      line-height: 1;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var textDecoration = xstyledStyledComponents_es.style({
  prop: 'textDecoration',
  cssProperty: 'textDecoration'
});
var textOverflow = xstyledStyledComponents_es.style({
  prop: 'textOverflow',
  cssProperty: 'textOverflow'
});
var wordBreak = xstyledStyledComponents_es.style({
  prop: 'wordBreak',
  cssProperty: 'wordBreak'
});
var gutterBottom = xstyledStyledComponents_es.style({
  prop: 'gutterBottom',
  cssProperty: 'marginBottom',
  themeGet: function themeGet(propValue) {
    return function () {
      return propValue * 16;
    };
  }
});
var whiteSpace = xstyledStyledComponents_es.style({
  prop: 'whiteSpace',
  cssProperty: 'whiteSpace'
});
var marginHorizontal = xstyledStyledComponents_es.style({
  prop: 'marginHorizontal',
  cssProperty: ['marginRight', 'marginLeft'],
  themeGet: xstyledStyledComponents_es.getSpace
});
var marginVertical = xstyledStyledComponents_es.style({
  prop: 'marginVertical',
  cssProperty: ['marginTop', 'marginBottom'],
  themeGet: xstyledStyledComponents_es.getSpace
});
var paddingHorizontal = xstyledStyledComponents_es.style({
  prop: 'paddingHorizontal',
  cssProperty: ['paddingRight', 'paddingLeft'],
  themeGet: xstyledStyledComponents_es.getSpace
});
var paddingVertical = xstyledStyledComponents_es.style({
  prop: 'paddingVertical',
  cssProperty: ['paddingTop', 'paddingBottom'],
  themeGet: xstyledStyledComponents_es.getSpace
});
var color = xstyledStyledComponents_es.style({
  prop: 'color',
  themeGet: xstyledStyledComponents_es.getColor
});
var legacyColor = xstyledStyledComponents_es.createStyleGenerator(function (props) {
  return {
    color: "".concat(styles_themeUtils.nuDSColor(props.color, props.colorVariant)())
  };
}, ['color']);
var styleProps = xstyledStyledComponents_es.compose(xstyledStyledComponents_es.layout, xstyledStyledComponents_es.textAlign, textDecoration, textOverflow, xstyledStyledComponents_es.overflow, wordBreak, xstyledStyledComponents_es.space, whiteSpace, marginHorizontal, marginVertical, paddingHorizontal, paddingVertical, color);

function appendDefaultFontFamily(newFontFamily) {
  // eslint-disable-next-line quotes
  var defaultFonts = "'Graphik-Regular', 'Gotham SSm A', 'Gotham SSm B', 'Helvetica Neue', Helvetica, Arial,sans-serif";
  return newFontFamily ? "".concat(newFontFamily, ", ").concat(defaultFonts) : defaultFonts;
}

var stylesByVariantMap = {
  supertitle: styles_breakpoints.breakpointsMedia({
    xs: xstyledStyledComponents_es.css(_templateObject()),
    md: xstyledStyledComponents_es.css(_templateObject2())
  }),
  title: styles_breakpoints.breakpointsMedia({
    xs: xstyledStyledComponents_es.css(_templateObject3()),
    md: xstyledStyledComponents_es.css(_templateObject4())
  }),
  subtitle: styles_breakpoints.breakpointsMedia({
    xs: xstyledStyledComponents_es.css(_templateObject5()),
    md: xstyledStyledComponents_es.css(_templateObject6())
  }),
  subtitle2: xstyledStyledComponents_es.css(_templateObject7(), appendDefaultFontFamily()),
  action: xstyledStyledComponents_es.css(_templateObject8()),
  paragraph1: xstyledStyledComponents_es.css(_templateObject9(), appendDefaultFontFamily()),
  paragraph2: xstyledStyledComponents_es.css(_templateObject10()),
  text1: xstyledStyledComponents_es.css(_templateObject11()),
  text2: xstyledStyledComponents_es.css(_templateObject12())
};
/* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */

var createEllipsisStyle = function createEllipsisStyle(lines) {
  return xstyledStyledComponents_es.css(_templateObject13(), lines);
};
/* stylelint-enable value-no-vendor-prefix, property-no-vendor-prefix */


var ellipsis = function ellipsis(_ref) {
  var lines = _ref.lines;
  if (!lines) return null;

  if (utils_isType_isType.isType('object', lines)) {
    var stylesByBreakPoints = Object.keys(lines).reduce(function (prev, key) {
      return _extends._extends_1({}, prev, defineProperty.defineProperty({}, key, createEllipsisStyle(lines[key])));
    }, {});
    return styles_breakpoints.breakpointsMedia(stylesByBreakPoints);
  }

  return createEllipsisStyle(lines);
};

var InnerTypography = xstyledStyledComponents_es.createSystemComponent(React__default['default'], 'span', styleProps);
var TypographyWrapper = xstyledStyledComponents_es.styled(InnerTypography).withConfig({
  shouldForwardProp: function shouldForwardProp(prop, validate) {
    return validate(prop) && !styleProps.meta.props.includes(prop);
  }
})(_templateObject14(), appendDefaultFontFamily('Graphik-Medium'), ellipsis, gutterBottom, styleProps, xstyledStyledComponents_es.variant({
  variants: stylesByVariantMap
}), function (_ref2) {
  var hasLegacyColor = _ref2.hasLegacyColor;
  return hasLegacyColor && xstyledStyledComponents_es.css(_templateObject15(), legacyColor);
});
TypographyWrapper.displayName = 'TypographyWrapper';
TypographyWrapper.propTypes = xstyledPropTypes_es.getSystemPropTypes(styleProps);

var validateColorProps = function validateColorProps(_ref) {
  var color = _ref.color,
      colorVariant = _ref.colorVariant;
  var isValid = true;

  if (styles_themeUtils.isLegacyColor(color) && color !== 'inherit') {
    utils_logger_logDeprecatedFeature_logDeprecatedFeature.logDeprecatedFeature('single color is deprecated, use use color=\'color.default\' instead');
    isValid = false;
  }

  if (colorVariant) {
    utils_logger_logDeprecatedFeature_logDeprecatedFeature.logDeprecatedFeature('colorVariant is deprecated, use color=\'color.variant\' instead');
    isValid = false;
  }

  return isValid;
};

var variantTagMapping = {
  supertitle: 'h1',
  title: 'h1',
  subtitle: 'h2',
  subtitle2: 'h2',
  action: 'span',
  paragraph1: 'p',
  paragraph2: 'p',
  text1: 'p',
  text2: 'p'
};
var typographyVariantsPropType = index.propTypes.oneOf(Object.keys(variantTagMapping));
var Typography = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var variant = props.variant,
      tag = props.tag,
      children = props.children,
      className = props.className,
      color = props.color,
      gutterBottom = props.gutterBottom,
      intlKey = props.intlKey,
      intlValues = props.intlValues,
      colorVariant = props.colorVariant,
      rest = objectWithoutProperties.objectWithoutProperties(props, ["variant", "tag", "children", "className", "color", "gutterBottom", "intlKey", "intlValues", "colorVariant"]);

  var _useContext = React.useContext(components_NuDSProvider_NuDSProvider.NuDsContext),
      formatMessage = _useContext.formatMessage;

  var intlAriaAttrs = utils_hooks_useIntlAriaAttrs['default'](props);
  var as = tag || variantTagMapping[variant];

  if (gutterBottom !== null && gutterBottom !== void 0 ? gutterBottom : false) {
    utils_logger_logDeprecatedFeature_logDeprecatedFeature.logDeprecatedFeature('gutterBottom is deprecated, use marginBottom instead of gutterBottom');
  }

  var hasLegacyColor = !validateColorProps({
    color: color,
    colorVariant: colorVariant
  });
  return /*#__PURE__*/React__default['default'].createElement(TypographyWrapper, _extends._extends_1({
    forwardedAs: as,
    className: className,
    color: color,
    colorVariant: colorVariant,
    gutterBottom: gutterBottom,
    variant: variant,
    hasLegacyColor: hasLegacyColor,
    ref: ref
  }, intlAriaAttrs, rest), intlKey ? formatMessage({
    id: intlKey
  }, intlValues) : children);
});
Typography.defaultProps = {
  children: undefined,
  className: undefined,
  color: 'inherit',
  // TODO: Remove it after upgrade color usage in all websites
  colorVariant: undefined,
  gutterBottom: 0,
  lines: undefined,
  tag: undefined,
  variant: 'paragraph1',
  intlKey: null,
  intlValues: {},
  margin: undefined,
  marginTop: undefined,
  marginBottom: undefined,
  marginLeft: undefined,
  marginRight: undefined,
  marginHorizontal: undefined,
  marginVertical: undefined,
  padding: undefined,
  paddingTop: undefined,
  paddingBottom: undefined,
  paddingLeft: undefined,
  paddingRight: undefined,
  paddingHorizontal: undefined,
  paddingVertical: undefined,
  width: undefined,
  height: undefined,
  minWidth: undefined,
  maxWidth: undefined,
  minHeight: undefined,
  maxHeight: undefined,
  size: undefined,
  display: undefined,
  verticalAlign: undefined,
  overflow: undefined,
  overflowX: undefined,
  overflowY: undefined,
  textOverflow: undefined,
  wordBreak: undefined,
  textDecoration: undefined,
  whiteSpace: undefined
};
var typographyShape = {
  /** The content of the component, it can be either another component or raw text */
  children: index.propTypes.node,

  /** The class that will be applied to the HTML element */
  className: index.propTypes.string,

  /**
   * The color of the text;
   * This can be a NuDS color token or an browser specific value (initial, inherit)
  */
  color: index.propTypes.string,

  /**
   * The variant of the color that you want to use;
   * The variants can be found on "Colors" section
   * */
  colorVariant: styles_colors_colorVariantsShape['default'],

  /**
    Margin at the bottom of the component; It's computed in multiples of 16px
    (1 = 16px; 2 = 32px, etc.)
  */
  gutterBottom: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),

  /** An i18n key that will be used to search for content */
  intlKey: index.propTypes.string,

  /** An object containing the values to be passed down to the internationalized message */
  intlValues: index.propTypes.shape({}),

  /** The number of lines that can be showed */
  lines: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),

  /** The actual HTML element to be rendered */
  tag: index.propTypes.elementType,

  /** The font style that will be rendered */
  variant: typographyVariantsPropType,
  margin: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  marginTop: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  marginBottom: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  marginLeft: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  marginRight: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  marginHorizontal: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  marginVertical: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  padding: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  paddingTop: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  paddingBottom: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  paddingLeft: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  paddingRight: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  paddingHorizontal: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  paddingVertical: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  width: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  height: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  minWidth: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  maxWidth: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  minHeight: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  maxHeight: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  size: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  display: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  verticalAlign: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  overflow: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  overflowX: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  overflowY: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  textOverflow: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  wordBreak: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  textDecoration: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  whiteSpace: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object])
};
Typography.propTypes = typographyShape;
Typography.displayName = 'Typography';

exports.default = Typography;
exports.typographyShape = typographyShape;
exports.typographyVariantsPropType = typographyVariantsPropType;
exports.variantTagMapping = variantTagMapping;
//# sourceMappingURL=Typography.js.map
